import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import menuPortalProps from 'helpers/reactSelectPortal';
import { createCar, updateCar } from 'redux/booking/car/carSlice';
import { debounce, filterOptions } from 'helpers/debounce';
import { Drawer, Button, FormRow } from 'components/common';

import { INPUT_CLS as inputClass } from 'helpers/formStyles';
const CarForm = ({ showModal, setshowModal, title, car }) => {
  const { control, register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const dispatch = useDispatch();

  const defaultSiteOption = useMemo(() => (car ? { value: car.site_id, label: car.site_name } : ''), [car]);

  useEffect(() => { if (title === 'New Car') reset(); }, [title, reset]);
  useEffect(() => { if (car) Object.entries(car).forEach(([key, value]) => setValue(key, value)); }, [setValue, car]);

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      if (car) dispatch(updateCar({ carId: car.id, data }));
      else dispatch(createCar(data));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const debouncedFilterSites = debounce((inputValue, callback) => filterOptions('/organization/sites', inputValue).then(callback), 300);
  const siteOptions = (inputValue, callback) => debouncedFilterSites(inputValue, callback);

  return (
    <Drawer
      show={showModal}
      onHide={closeModal}
      title={title}
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="car-form" variant="primary">Save</Button>
        </>
      )}
    >
      <form id="car-form" onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Car name" error={errors.name?.message}>
          <input type="text" placeholder="Car name" className={inputClass} {...register('name', { required: 'Car name must be required.' })} />
        </FormRow>
        <FormRow label="Model" error={errors.model?.message}>
          <input type="text" placeholder="Model" className={inputClass} {...register('model', { required: 'Model must be required.' })} />
        </FormRow>
        <FormRow label="Active">
          <Controller control={control} name="active" defaultValue
            render={({ field }) => (
              <label className="tw-inline-flex tw-items-center tw-gap-2 tw-cursor-pointer">
                <input type="checkbox" checked={!!field.value} onChange={(e) => setValue('active', e.target.checked)} />
                <span className="tw-text-sm tw-text-slate-600">Active</span>
              </label>
            )} />
        </FormRow>
        <FormRow label="Note">
          <textarea rows={6} placeholder="Note" className={inputClass} {...register('remark')} />
        </FormRow>
        <FormRow label="Site" error={errors.site_id?.message}>
          <Controller control={control} name="site_id" rules={{ required: { value: true, message: 'Site must be required' } }}
            render={() => (
              <AsyncSelect cacheOptions defaultOptions defaultValue={defaultSiteOption} loadOptions={siteOptions} closeMenuOnSelect placeholder="Select..." classNamePrefix="react-select" {...menuPortalProps}
                onChange={(opt) => setValue('site_id', opt.value)} />
            )} />
        </FormRow>
      </form>
    </Drawer>
  );
};

CarForm.propTypes = {
  showModal: PropTypes.bool,
  setshowModal: PropTypes.func,
  title: PropTypes.string,
  car: PropTypes.object,
};

export default CarForm;
